import { ConfigProvider, Select, Typography } from 'antd';
import type { SelectProps } from 'antd/es/select';
import { CheckOutlined } from '@ant-design/icons';
import { themeConfig } from '@acast-tech/echo-theme';
import { twMerge } from 'tailwind-merge';

interface MultiSelectEchoProps extends Omit<SelectProps<string[]>, 'mode'> {
  transparentTag?: boolean;
}

const defaultOptionRender: SelectProps<string[]>['optionRender'] = (option) => (
  <Typography.Text strong={option.data.isSelected}>{option.label}</Typography.Text>
);

const defaultMenuItemSelectedIcon = (
  <CheckOutlined style={{ color: themeConfig.token?.colorPrimary }} />
);

const MultiSelectEcho = ({
  optionRender = defaultOptionRender,
  menuItemSelectedIcon = defaultMenuItemSelectedIcon,
  className,
  transparentTag = false,
  ...props
}: MultiSelectEchoProps) => {
  const select = (
    <Select<string[]>
      {...props}
      mode="multiple"
      optionRender={optionRender}
      menuItemSelectedIcon={menuItemSelectedIcon}
      className={twMerge('w-full min-w-0', className)}
    />
  );

  if (!transparentTag) return select;

  return (
    <ConfigProvider theme={{ components: { Select: { multipleItemBg: 'transparent' } } }}>
      {select}
    </ConfigProvider>
  );
};

export { MultiSelectEcho };
